module.exports = __webpack_public_path__ + "img/vbc.3788a48b.svg";